import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useCallback } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { followUpFormsRequest } from './actions/followUpFormActions';
import SimpleDropdown from '../../components/Drowpdowns/SimpleDropdown';
import FollowUpForm from './components/FollowUpForm';
import validateZendeskForm from '../../utils/validateZendeskForm';
import NOB from '../../constants/language-strings';
import zendeskBody from '../../utils/zendeskBody';
import { INPUT_TYPES } from './FollowUpConstans';
import { WORK_LOG_URL } from '../../constants/paths';
import { postZendeskFollowUpRequest, saveFollowUpFile } from '../WorkLog/actions/zendeskActions';
import SlideInPage from '../../components/SlideInPage/SlideInPage';
import './follow-up.scss';
import { useLocation } from 'react-router';
import { useWorkOrder } from 'modules/Workorder/api';
const FollowUpFormsContainer = ({ requestForms, forms, saveFiles, push, postZendeskRequest, followUp, }) => {
    var _a;
    const location = useLocation();
    const workOrderId = Number((_a = location.pathname.match(/workOrder\/(\d+)/)) === null || _a === void 0 ? void 0 : _a[1]);
    const [chosenForm, setChosenForm] = useState(NOB.FOLLOW_UP.DEFAULT_DROPDOWN_VALUE);
    const [touched, setTouched] = useState(false);
    const { workOrder } = useWorkOrder(workOrderId);
    const { files, isFetching } = followUp;
    useEffect(() => {
        requestForms();
    }, [requestForms]);
    const getChosenForm = useCallback(() => forms.find(form => form.name === chosenForm), [forms, chosenForm]);
    const handleFormChange = event => {
        setChosenForm(event.value);
        setTouched(false);
    };
    const handleSubmit = values => {
        const zendesk = {
            followUpFormValues: values,
            files,
        };
        const body = zendeskBody(workOrder, zendesk, false);
        setTouched(true);
        if (validateZendeskForm(values, getChosenForm())) {
            postZendeskRequest(body);
            push(WORK_LOG_URL(workOrderId));
        }
    };
    const formList = forms.map(form => ({
        name: form.name,
        value: form.name,
    }));
    const selectedForm = getChosenForm();
    return (_jsxs(SlideInPage, { showLeftIcon: true, mainHeading: NOB.FOLLOW_UP.FOLLOW_UP, isFetching: isFetching, children: [_jsx("div", { className: "followup-content-heading-label", children: INPUT_TYPES.HEADING }), _jsx(SimpleDropdown, { isWhite: true, values: formList, onChange: handleFormChange, title: chosenForm }), selectedForm && (_jsx(FollowUpForm, { form: selectedForm, files: files, onSubmit: handleSubmit, isSubmitted: touched, saveFiles: saveFiles }))] }));
};
FollowUpFormsContainer.propTypes = {
    requestForms: PropTypes.func.isRequired,
    forms: PropTypes.arrayOf(PropTypes.any).isRequired,
    saveFiles: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
    postZendeskRequest: PropTypes.func.isRequired,
    followUp: PropTypes.objectOf(PropTypes.any).isRequired,
};
const mapStateToProps = state => ({
    followUp: state.zendesk.followUpForm,
    forms: state.followUpForms.forms,
});
const mapDispatchToProps = dispatch => ({
    requestForms: () => dispatch(followUpFormsRequest()),
    postZendeskRequest: body => dispatch(postZendeskFollowUpRequest(body)),
    saveFiles: files => dispatch(saveFollowUpFile(files)),
    push: path => dispatch(push(path)),
});
export default connect(mapStateToProps, mapDispatchToProps)(FollowUpFormsContainer);
